import styled from "styled-components";
import {breakpoints} from "@vfit/shared/themes";

export const WinbackContainer = styled.div`
  @media(min-width: ${breakpoints.desktop}) {
    margin-top: 120px;
  }
`;
